export const buildProductWeightBoxBody = () => {
    return {
        kilo: document.getElementById('kilo').value,
        meter: document.getElementById('meter').value,
    }
}

export const validateProductWeightBody = (body) => {
    
    if(body.kilo === null || body.kilo === '' || body.kilo<= 0){
        throw new Error('La cantidad de gramos no es valida');
    }
    if(body.meter === null || body.meter === '' || body.meter<= 0){
        throw new Error('La cantidad de metros no es valida');
    }

}

export const validatePercentBody = (percent) => {

    if(percent === null || percent === '' || percent<0.1){
        throw new Error('El porcentaje es erroneo');
    }
}

